import * as React from 'react';

import {CellAiSummary} from './ai-summary';
import {CellMatchedContacts} from './matched-contacts';

function getCellForField(fieldName: string): React.ComponentType<{
    entityId: string;
}> {
    switch (fieldName) {
        case 'matchedContacts': {
            return CellMatchedContacts;
        }
        case 'aiSummary': {
            return CellAiSummary;
        }
        default: {
            return CellMatchedContacts;
        }
    }
}

type Props = {
    name: string;
    entityId?: string | null | undefined;
};

export function CellAsync(props: Props) {
    const RowComponent = getCellForField(props.name);

    if (props.entityId == null) {
        return null;
    }

    return <RowComponent entityId={props.entityId} />;
}
